import { getAuth } from "firebase/auth";
import { useCallback, useEffect, useState } from "react";
import { isValidPhoneNumber } from "react-phone-number-input";
import { useLocation, useNavigate } from "react-router-dom";
import CreateTransport from "../../../../Controllers/Admin/Transports/CreateTransport";
import GetSingleTransport from "../../../../Controllers/Admin/Transports/GetSingleTransport";
import UpdateTransport from "../../../../Controllers/Admin/Transports/UpdateTransport";
import GetUser from "../../../../Controllers/Users/GetUser";
import { ToastSuccessMessages } from "../../../../Helpers/ToastMessages";

export default function AddTransportViewModel() {
  const navigate = useNavigate();
  const location = useLocation();
  const [SchoolID, setSchoolID] = useState("");

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem("schoolId"));
    setSchoolID(items);
  }, []);

  const [TransportID, setTransportID] = useState("");

  const [AuthUser, setAuthUser] = useState("");

  const [RouteNameError, setRouteNameError] = useState(false);
  const [VehicleNumberError, setVehicleNumberError] = useState(false);
  const [DriverNameError, setDriverNameError] = useState(false);
  const [ContactNumberError, setContactNumberError] = useState(false);
  const [DriverAddressError, setDriverAddressError] = useState(false);

  const [FormDisabled, setFormDisabled] = useState(false);
  const [IsUpdate, setIsUpdate] = useState(false);

  const [IsCheckError, setIsCheckError] = useState(false);
  const [AddTransport, setAddTransport] = useState({
    RouteName: "",
    VehicleNumber: "",
    DriverName: "",
    DriverLicense: "",
    ContactNumber: "",
    DriverAddress: "",
  });
  const [ContactNo, setContactNo] = useState("");

  const HandleContactNumberFormat = (event) => {
    const limit = 11;
    setContactNo(event.target.value.slice(0, limit));
  };

  useEffect(() => {
    const LocationArray = location.pathname.split("/");
    setTransportID(LocationArray.pop());

    if (LocationArray.includes("update")) {
      setIsUpdate(true);
      const fetchData = async () => {
        const TransportData = await GetSingleTransport(TransportID);
        setAddTransport({
          RouteName: TransportData?.RouteName,
          VehicleNumber: TransportData?.VehicleNumber,
          DriverName: TransportData?.DriverName,
          DriverLicense: TransportData?.DriverLicense,
          ContactNumber: TransportData?.ContactNumber,
          DriverAddress: TransportData?.DriverAddress,
        });
        setContactNo(TransportData?.ContactNumber);
      };
      fetchData();
    } else {
    }
  }, [location.pathname, TransportID]);

  useEffect(() => {
    async function fetchData() {
      getAuth().onAuthStateChanged(async (user) => {
        const UserData = await GetUser(user?.uid);
        setAuthUser(UserData);
      });
    }
    fetchData();
  }, []);

  const UIErrorHandling = useCallback(() => {
    let flag = 0;

    if (
      AddTransport.RouteName === "" ||
      AddTransport.RouteName === null ||
      AddTransport.RouteName === undefined ||
      AddTransport.RouteName.length < 3
    ) {
      setRouteNameError(true);
      flag++;
    } else {
      setRouteNameError(false);
    }

    if (
      AddTransport.VehicleNumber === "" ||
      AddTransport.VehicleNumber === null ||
      AddTransport.VehicleNumber === undefined
    ) {
      setVehicleNumberError(true);
      flag++;
    } else {
      setVehicleNumberError(false);
    }

    if (
      AddTransport.DriverName === "" ||
      AddTransport.DriverName === null ||
      AddTransport.DriverName === undefined ||
      AddTransport.DriverName.length < 3
    ) {
      setDriverNameError(true);
      flag++;
    } else {
      setDriverNameError(false);
    }

    if (
      AddTransport.ContactNumber === "" ||
      AddTransport.ContactNumber === null ||
      AddTransport.ContactNumber === undefined ||
      !isValidPhoneNumber(AddTransport.ContactNumber)
    ) {
      setContactNumberError(true);
      flag++;
    } else {
      setContactNumberError(false);
    }

    if (
      AddTransport.DriverAddress === "" ||
      AddTransport.DriverAddress === null ||
      AddTransport.DriverAddress === undefined ||
      AddTransport.DriverAddress.length < 3
    ) {
      setDriverAddressError(true);
      flag++;
    } else {
      setDriverAddressError(false);
    }

    return flag;
  }, [
    AddTransport.RouteName,
    AddTransport.VehicleNumber,
    AddTransport.DriverName,
    AddTransport.ContactNumber,
    AddTransport.DriverAddress,
  ]);

  useEffect(() => {
    if (IsCheckError) UIErrorHandling();
  }, [IsCheckError, UIErrorHandling]);

  const RegisterTransport = async () => {
    setIsCheckError(true);
    let flag = 0;
    flag = UIErrorHandling();

    if (flag === 0) {
      setFormDisabled(true);
      if (IsUpdate) {
        const TransportFinalObject = {
          ...AddTransport,
        };

        await UpdateTransport(TransportFinalObject, TransportID)
          .then(() => {
            ToastSuccessMessages("transport/update-successful");
            navigate("/user/admin/transport");
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        const TransportFinalObject = {
          ...AddTransport,
        };

        await CreateTransport(TransportFinalObject, AuthUser?.uid, SchoolID)
          .then(() => {
            ToastSuccessMessages("transport/add-successful");
            navigate("/user/admin/transport");
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {
      setFormDisabled(false);
    }
  };

  return {
    RegisterTransport,
    AddTransport,
    setAddTransport,
    ContactNo,
    HandleContactNumberFormat,
    RouteNameError,
    VehicleNumberError,
    DriverNameError,
    ContactNumberError,
    DriverAddressError,
    FormDisabled,
    IsUpdate,
  };
}
